import { ActionReducerMap, MetaReducer, ActionReducer } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { routerReducer } from '@ngrx/router-store';
import { AppState } from 'src/app/core/models/app-state.models';
import * as fromSession from './session.reducers';

import * as fromTitlebar from './titlebar.reducers';


export const reducers: ActionReducerMap<AppState> = {
  router: routerReducer,
  session: fromSession.reducer,
  
  titlebar: fromTitlebar.reducer,
  
};

export function resetStore(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    if (action.type === '[Auth] Logout success' || action.type === '[Auth] Logout failed') {
      state = undefined;
    }
    return reducer(state, action);
  };
}


export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [resetStore] : [resetStore];
